module.exports = __webpack_public_path__ + "static/img/siglogo.d4397c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/siglogo.png
// module id = D32m
// module chunks = 0